import type { ZodError } from 'zod';

export const parseZodError = (error: ZodError): string[] =>
  error.issues.map((issue) => {
    const path = issue.path.length > 0 ? ` at ${issue.path.join('.')}` : '';
    return `${issue.message}${path}`;
  });

export const apiErrorLogger = (error: unknown): void => {
  if (error instanceof Error) {
    console.error('API Error:', error.message);
    if (error.stack) {
      console.error('Stack trace:', error.stack);
    }
  } else {
    console.error('Unknown API Error:', error);
  }
};
